import { ResponsiveComponentProps, ResponsiveWrapper } from '../ResponsiveWrapper';
import { LineChartBase, LineChartBaseProps } from './LineChartBase';

export type ResponsiveLineChartProps = ResponsiveComponentProps<LineChartBaseProps>;

export function ResponsiveLineChart({
  width: overrideWidth,
  height: overrideHeight,
  ...componentProps
}: ResponsiveLineChartProps) {
  return (
    <ResponsiveWrapper width={overrideWidth} height={overrideHeight}>
      {({ width, height }) => {
        return <LineChartBase width={width} height={height} {...componentProps} />;
      }}
    </ResponsiveWrapper>
  );
}
